export default __webpack_public_path__ + "static/media/Course-Icons4.2f220aa6.svg";